export const CREATE_DOCTOR = {
  REQUEST: "CREATE_DOCTOR_REQUEST",
  SUCCESS: "CREATE_DOCTOR_SUCCESS",
  FAIL: "CREATE_DOCTOR_FAIL",
};

export const GET_DOCTOR = {
  REQUEST: "GET_DOCTOR_REQUEST",
  SUCCESS: "GET_DOCTOR_SUCCESS",
  FAIL: "GET_DOCTOR_FAIL",
};

export const GET_DOCTORS = {
  REQUEST: "GET_DOCTORS_REQUEST",
  SUCCESS: "GET_DOCTORS_SUCCESS",
  FAIL: "GET_DOCTORS_FAIL",
};

export const UPDATE_DOCTOR = {
  REQUEST: "UPDATE_DOCTOR_REQUEST",
  SUCCESS: "UPDATE_DOCTOR_SUCCESS",
  FAIL: "UPDATE_DOCTOR_FAIL",
};

export const DELETE_DOCTOR = {
  REQUEST: "DELETE_DOCTOR_REQUEST",
  SUCCESS: "DELETE_DOCTOR_SUCCESS",
  FAIL: "DELETE_DOCTOR_FAIL",
};

export const UPDATE_DOCTOR_ADMIN_STATUS = {
  REQUEST: "UPDATE_DOCTOR_ADMIN_STATUS_REQUEST",
  SUCCESS: "UPDATE_DOCTOR_ADMIN_STATUS_SUCCESS",
  FAIL: "UPDATE_DOCTOR_ADMIN_STATUS_FAIL",
};

export const GET_ASSIGNED_PATIENTS = {
  REQUEST: "GET_ASSIGNED_PATIENTS_REQUEST",
  SUCCESS: "GET_ASSIGNED_PATIENTS_SUCCESS",
  FAIL: "GET_ASSIGNED_PATIENTS_FAIL",
};
